import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { HERO_IMAGE, BRAND } from "../mock";

export default function Hero() {
  return (
    <section className="relative pt-[68px] lg:pt-[76px] overflow-hidden">
      <div className="relative h-[92vh] min-h-[640px] w-full">
        <img
          src={HERO_IMAGE}
          alt="Athlete training outdoors"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/15 via-black/30 to-[var(--lc-ink)]/85" />

        <div className="absolute inset-0 flex items-end">
          <div className="mx-auto max-w-[1400px] w-full px-5 lg:px-10 pb-16 lg:pb-24">
            <div className="grid lg:grid-cols-12 gap-6 lg:gap-10 items-end">
              <div className="lg:col-span-8">
                <div className="eyebrow text-[var(--lc-sand)] mb-5 fade-up">
                  {BRAND.location} · Total Body Transformation
                </div>
                <h1 className="font-serif-display text-[clamp(40px,7.2vw,108px)] leading-[0.95] font-light text-white fade-up" style={{ animationDelay: "0.1s" }}>
                  Longevity, <span className="italic">engineered</span> for
                  <br />your lifetime.
                </h1>
              </div>
              <div className="lg:col-span-4 fade-up" style={{ animationDelay: "0.25s" }}>
                <p className="text-white/85 text-[15px] leading-relaxed max-w-md mb-8">
                  The first fully integrated longevity ecosystem in Basel. Six
                  pillars of elite health — one cohesive coaching plan.
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Link
                    to="/packages"
                    className="group inline-flex items-center justify-between gap-3 px-6 py-4 bg-[var(--lc-moss)] hover:bg-[var(--lc-moss-dark)] text-white transition-colors"
                  >
                    <span className="text-[12px] font-bold tracking-[0.18em] uppercase">View Packages</span>
                    <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </Link>
                  <Link
                    to="/build"
                    className="group inline-flex items-center justify-between gap-3 px-6 py-4 bg-white/10 hover:bg-white/20 backdrop-blur-md text-white border border-white/30 transition-colors"
                  >
                    <span className="text-[12px] font-bold tracking-[0.18em] uppercase">Build Your Plan</span>
                    <ArrowUpRight className="h-4 w-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Floating stat strip */}
        <div className="hidden lg:flex absolute top-32 right-10 flex-col gap-3 text-white max-w-[260px]">
          <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-md px-4 py-3">
            <div className="text-[10px] tracking-[0.2em] uppercase text-[var(--lc-sand)]">Pillars</div>
            <div className="font-serif-display text-3xl mt-1">6 × 1</div>
            <div className="text-[11px] text-white/70 mt-1">Six disciplines, one plan</div>
          </div>
        </div>
      </div>
    </section>
  );
}
